import React from "react";
import Link from "gatsby-link";
import Helmet from "react-helmet";
import Buynow from "../components/Buynow";
import CategoryDropdown from "../components/CategoryDropdown";

export default function Index({ data, pathContext }) {

  const { edges: posts } = data.allEJitem;
  const { edges: categories } = data.allEJcategory;

  return (
    <div className="page-wrapper">
      <Helmet title={'Category: ' + pathContext.category + ' - Falken\'s Party Supplies'} />
      <section className="blog-hero">
        <div className="container">
          <h1>Category: {pathContext.category}</h1>
        </div>
      </section>   
      <section className="home-products">
        <div className="container">
          <div className="filter-options">
              <div className="searchbox">
                <form id="searchbox" action="" method="GET"><input type="text" name="search" id="search" placeholder="Search" /><input type="submit" value="Search" /></form>
              </div>
            <CategoryDropdown categories={categories} current={pathContext.category} />
          </div>
          <div className="ej-shop-index">   
          {posts
            .filter(post => post.node.name.length > 0)
            .map(({ node: post }) => {
              if(post.tags.indexOf(pathContext.category) > -1)
              {
                return (
                  <div className="ej-item" key={post.id}>
                    <img src={post.image} alt={post.name} />
                    <div className="product-blurb">
                      <h2>
                        {post.name}
                      </h2>
                      <p>{post.description}</p>
                      <p>${post.price}</p>
                      <div className="item-tags">{post.tags}</div>
                      <Buynow  post={post} />
                    </div>
                  </div>
                );                
              }
              else
              {
                return ('');
              }

            })}
          </div>
        </div>
      </section>
    </div>
  );
}

export const pageQuery = graphql`
  query CATQuery {
    allEJitem {
      edges {
        node {
          id
          currency
          description
          details
          image
          name
          number
          needs_advance_options
          option1
          option1_options
          option2
          option2_options
          option3
          option3_options
          price
          thumbnail
          tagline
          download_link
          homepage_link
          needs_options
          on0
          on0_options
          on1
          on1_options
          on2
          on2_options
          purchased
          tags
          item_expiry
          aff_perc
          variable_pricing
          file_size
          source_country
          needs_download
          needs_keygen
          product_extension
          needs_exhaust_password
          needs_multiple
          sub_items{
            option1_value
            option2_value
            option3_value
            price
        }
          ej_shop_id
        }
      }
    },
    allEJcategory( sort: {fields: [name], order: ASC}) {
      edges {
        node {
          id
          name
          root
          path
        }
      }
      }
  }
`;


// WEBPACK FOOTER //
// ./src/pages/category.js